<button [class]="buttonClass" (click)="onClick()"><ng-container *ngIf="iconClass">
        <i class="{{ iconClass }}"></i>&nbsp;
    </ng-container>{{ buttonText }}</button>